import { useEffect } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Table } from 'reactstrap';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import { setPovrchy } from '../redux/actions/prvkyActions';
import RecommTable from '../comp/RecommTable';
import TextOrMdash from '../comp/TextOrMdash';
import DisplayFoto from '../comp/DisplayFoto';
//
import URLEndPointBE from '../comp/URLEndPointBE';
import DeEscapeTxt from '../comp/DeEscapeTxt';

function ViewingPovrch() {
    const { keycloak, initialized } = useKeycloak();
    const FetchSetPovrchy = async () => {
        const response: any = await axios
            .get(URLEndPointBE+`/listing/povrchy`)
            .catch((error) => {
                console.log("Err", error)
            });
        //return response.data;    
        dispatch(setPovrchy(response.data));
    }
    let { povrchId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
            //potential succ from insertion/edit redirect
            const {state} = useLocation();
            console.log(state)

    const povrchy = useSelector((state: any) => state.allPrvky.povrchy);
    let povrch_povrchId = povrchy.find((dopl: any) => (dopl.id===povrchId)) 

    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);

    console.log("displaying povrch")
    console.log(povrch_povrchId) 

    const DeletePovrch = () => {
        console.log("DeletePovrch() " + povrchId);
        axios.delete(URLEndPointBE+`/povrch/`+povrchId, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
        .then((response) => {
            console.log(response);
            //if response.data success - go /listing/povrchy - ERROR HERE ON DB
            console.log(response.data);
            console.log(response.data.success);
            if(response.data.success==1) {
                console.log("redirecting")
                setTimeout(function() {
                    navigate('/listing/povrchy', {state: {succ: true, type: 'SMAZANI', item: 'POVRCHU'}});
                }, 1500);
            }
            else {
                console.log ("err")
            }
        })
        .catch(function(error) {
            console.log(error);
        })
    }

    useEffect(() => {
        dispatch(setMenuSelected("povrchy"));
        FetchSetPovrchy();

        if (povrchId && povrchId !== "")
            console.log("povrchId && povrchId !== \"\"")        
        return () => {
            //why?
        };
    }, [povrchId])

    return (
        <Container>
        {/*/@ts-ignore*/}
        {(state?.succ)?<Row className={"succRow"}>
        {/*/@ts-ignore*/}
        <span className={"succTxtInside"}>Úspěch - {state?.type} {state?.item} </span>
        </Row>:<></>}
            <Table hover>
                <thead>
                    <tr>
                        <th className='justWrap'>{DeEscapeTxt(povrch_povrchId?.kod)}</th>
                        <th><span>{DeEscapeTxt(povrch_povrchId?.nazev)}</span>
                            <span>&nbsp;
                            {keycloak.authenticated && ( <span>   
                            <Link className="navRemoveUnderscoreInLinkA" to={"/povrchy/edit/"+povrch_povrchId?.id}>
                                <span className="katBtnStyle printHide" >EDITOVAT</span>
                            </Link> &nbsp;
                            <span className="katBtnStyle ptHover printHide" onClick={() => {DeletePovrch()}}>SMAZAT</span>
                            </span>)}
                            </span>
                           
                            <span className="print" onClick={()=>window.print()}>&nbsp;&#9113;&nbsp;</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row" className='justWrap'>VZOREK</th>
                        <td align='center'>{(typeof (povrch_povrchId?.foto) !== 'undefined' && povrch_povrchId?.foto != null)
                        ? <span style={{display:"inline-block", width:"340px", }}><div>{povrch_povrchId?.foto.map((foto: any) => <DisplayFoto key={foto.fotoId} foto={foto}/>)}</div></span>
                        : <td>&mdash;</td>}</td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VIDITELNOST</th>
                        <td>{(typeof (viditelnost) !== 'undefined' && viditelnost != null)
                            ? <TextOrMdash text={viditelnost.find((vid: any)=>vid.key===povrch_povrchId?.viditelnost)?.value} />
                            : <div>&mdash;</div>}</td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POVRCHY POUZITI</th>
                        <td>{(typeof (povrch_povrchId?.povrchyPouziti) !== 'undefined' && povrch_povrchId?.povrchyPouziti != null)
                            ? <RecommTable recommendations={povrch_povrchId?.povrchyPouziti} />
                            : <div>&mdash;</div>}</td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>PODMÍNKA</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.podminkaobecna)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POPIS</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.popis)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VÝŠKA NÁŠLAPNÉ VRSTVY</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.naslapnavrstva_v)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>ZÁKLADNÍ (povolené) FORMÁTY</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.format)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POUŽITÍ</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.pouziti)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>KLAD</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.klad)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POZNÁMKA</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.poznamka)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>MODIFIKACE/ VARIACE</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.modifikace)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOSTUPNOST</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.dostupnost)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>CENOVÁ HLADINA KRYTU (SOUVRSTVÍ)</th>
                        <td><TextOrMdash text={DeEscapeTxt(povrch_povrchId?.cenovahladina)}/></td>
                    </tr>
                </tbody>
            </Table>
        </Container>    
    )
}
export default ViewingPovrch